import Bandeira from "../Bandeira";
import { formatarNumero, paisDoNumero } from "../../helpers/numeroWhatsapp";
import { cn } from "../../lib/utils";

// Número de telefone com a bandeira do país ao lado.
//
// Serve para a equipe saber de onde é quem está falando antes de abrir a
// conversa — com contato de fora, "+351 912 345 678" e "+34 912 345 678" se
// parecem, e a bandeira separa os dois num relance.
//
// Grupo não tem país: o identificador é um número do próprio WhatsApp, e
// atribuir bandeira a ele seria invenção.

const NumeroComBandeira = ({ numero, ehGrupo = false, className }) => {
	if (!numero) return null;

	const pais = paisDoNumero(numero, ehGrupo);

	return (
		<span className={cn("inline-flex items-center gap-1.5", className)}>
			<Bandeira codigo={pais} />
			<span>{formatarNumero(numero, ehGrupo)}</span>
		</span>
	);
};

export default NumeroComBandeira;
